import {
  useStyle 
} from "@/classify";
import React from "react";

import Shimmer from "../Shimmer";
import defaultClasses from "./filterModalOpenButton.shimmer.module.css";

const FilterModalOpenButtonShimmer = props => {
  const classes = useStyle(defaultClasses, props.classes);

  return (
    <Shimmer
      classes={{
        root_button: classes.filterButtonShimmer 
      }}
      type='button'
      aria-live='polite'
      aria-busy='true'
    />
  );
};
 

export default FilterModalOpenButtonShimmer;
